const FileViewer = ({publication_type,file,name}) => {
  return (
    <div className="h-full">
        {publication_type === "image" && (
                <img
                  src={file}
                  alt={name}
                  className="w-full h-full rounded-[10px] object-cover"
                />
              )}
              {publication_type === "pdf" && (
                <iframe
                  src={`${file}#toolbar=0`}
                  title={name}
                  className="w-full h-full rounded-[10px]"
                />
              )}
              {(publication_type === "doc" || publication_type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    file
                  )}&embedded=true`}
                  title={name}
                  className="w-full h-full rounded-[10px]"
                />
              )}
              {publication_type === "video" && (
                <video
                  src={file}
                  controls
                  className="w-full h-full rounded-[10px] object-cover"
                />
              )}
              {publication_type === "audio" && (
                <div className="w-full h-full rounded-[10px] flex items-center justify-center bg-gray-100">
                  <audio src={file} controls className="w-full px-4" />
                </div>
              )}
    </div>
  )
}

export default FileViewer
